let digitalOptionCost = 650;
let smallPrintCost = 690;
let bigPrintCost = 850;

export {digitalOptionCost, smallPrintCost, bigPrintCost}